import React, { useEffect } from 'react';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import LoginPage from './pages/LoginPage';
import AdminDashboard from './components/AdminDashboard';
import ProductManagement from './components/ProductManagement';
import QuoteManagement from './components/QuoteManagement';
import SettingsPanel from './components/SettingsPanel';
import QuotePage from './components/QuotePage';
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';
import apiClient from './api/client';
import './App.css';
import ErrorBoundary from './components/ErrorBoundary';

// Import UI components
import { Card, CardContent, CardHeader, CardTitle } from './components/ui/card';
import { Button } from './components/ui/button';
import { Input } from './components/ui/input';
import { Textarea } from './components/ui/textarea';
import { Label } from './components/ui/label';
import { Badge } from './components/ui/badge';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from './components/ui/dialog';
import { Alert, AlertDescription } from './components/ui/alert';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from './components/ui/carousel';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './components/ui/tabs';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './components/ui/select';
import { Checkbox } from './components/ui/checkbox';
import { Menu, X, ShoppingCart, Mail, Phone, MapPin, Star, Users, Award, Shield, Plus, Trash2, Edit, Download, Package, FileText } from 'lucide-react';



// axios.defaults.withCredentials = true; # Re-Routing through apiClient hence commenting these lines.
// axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8081';

// Import other page components
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import CataloguePage from './pages/CataloguePage';
import ContactPage from './pages/ContactPage';
import TestimonialsPage from './pages/TestimonialsPage';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';

// Main App Component

if (process.env.NODE_ENV === 'production') {
  // Disable any development tools in production
  window.posthog = undefined;
  
  // Disable React DevTools in production
  if (window.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
    window.__REACT_DEVTOOLS_GLOBAL_HOOK__.inject = function() {};
  }
}

console.log('Running in environment:', process.env.NODE_ENV);
console.log('API base URL:', process.env.REACT_APP_BACKEND_URL || 'Using relative paths');
console.log('Frontend URL:', window.location.origin);

function App() {
	useEffect(() => {
	  // Log environment for debugging
	  console.log('Running in environment:', process.env.NODE_ENV);
	  console.log('API base URL:', process.env.REACT_APP_BACKEND_URL || 'Using relative paths');
	  console.log('Frontend URL:', window.location.origin);
	  
	  // Disable WebSocket connections in production
	  if (process.env.NODE_ENV === 'production') {
		// Override WebSocket to prevent connections
		const originalWebSocket = window.WebSocket;
		window.WebSocket = function() {
		  console.log('WebSocket connections disabled in production');
		  return {
			send: () => {},
			close: () => {},
			addEventListener: () => {},
			removeEventListener: () => {}
		  };
		};
		// Restore the prototype for compatibility
		Object.setPrototypeOf(window.WebSocket, originalWebSocket);
	  }
	}, []);

  return (
    <ErrorBoundary>
		<AuthProvider>
		  <Router>
			<div className="App">
			  <Header />
			  <main>
				<Routes>
				  <Route path="/login" element={<LoginPage />} />
				  <Route path="/forgot-password" element={<ForgotPassword />} />
				  <Route path="/reset-password" element={<ResetPassword />} />
				  
				  {/* Protected routes */}
				  <Route path="/admin/*" element={
					<PrivateRoute requireAdmin={true}>
					  <AdminDashboard />
					</PrivateRoute>
				  } />
				  
				  {/* Public routes */}
				  <Route path="/" element={<HomePage />} />
				  <Route path="/about" element={<AboutPage />} />
				  <Route path="/catalogue" element={<CataloguePage />} />
				  <Route path="/contact" element={<ContactPage />} />
				  <Route path="/testimonials" element={<TestimonialsPage />} />
				  <Route path="/quote" element={<QuotePage />} />
				  
				  {/* Catch all route - redirect to home */}
				  <Route path="*" element={<Navigate to="/localhost" />} />
				</Routes>
			  </main>
			  <Footer />
			</div>
		  </Router>
		</AuthProvider>
	</ErrorBoundary>
  );
}

export default App;